import * as React from 'react';
import { Dialog } from '../dialog/Dialog';
import { DialogBody } from '../dialog/DialogBody';
import { Text } from '../typography/Text';
import { IProps } from '../common/props';
import { Spinner } from '../spinner/Spinner';
import { Space } from '../space/Space';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { ModalComponentProps } from '../modal/ModalManager';

export type WaitingModalProps = IProps &
  Omit<ModalComponentProps, 'onClose'> & {
    onClose?:
      | ((e?: React.SyntheticEvent<HTMLElement>) => void)
      | ((e?: React.MouseEvent<HTMLElement>) => void);
  };

export const WaitingModal: React.FC<WaitingModalProps> = ({
  children,
  title = 'Probíhá zpracování požadované akce',
  className,
}) => {
  return (
    <Dialog className={classNames(Classes.WAITING_DIALOG, className)}>
      <DialogBody disableScroll className={Classes.WAITING_DIALOG_BODY}>
        <Space vertical size={'2'}>
          <Text type={'block'} className={Classes.WAITING_DIALOG_TITLE}>
            {title}
          </Text>
          <Spinner />
          {children && <div>{children}</div>}
        </Space>
      </DialogBody>
    </Dialog>
  );
};
